import React from 'react';
import { motion } from 'framer-motion';

interface SleepMetricCardProps {
  title: string;
  value: string | number;
  unit?: string;
  icon: React.ReactNode;
  status?: 'success' | 'warning' | 'error';
  comparison?: string;
}

export function SleepMetricCard({ title, value, unit, icon, status, comparison }: SleepMetricCardProps) {
  const statusColors = {
    success: 'text-success',
    warning: 'text-warning',
    error: 'text-destructive'
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="theme-card p-4 relative overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-50" />
      <div className="relative">
        <div className="flex items-center gap-2 text-sm text-muted-foreground mb-2">
          {icon}
          <span>{title}</span>
        </div>
        <div className="flex items-baseline gap-2">
          <div className="text-2xl font-bold">{value}</div>
          {unit && <div className="text-sm text-muted-foreground">{unit}</div>}
        </div>
        {comparison && (
          <div className={`text-xs mt-1 ${status ? statusColors[status] : ''}`}>
            {comparison}
          </div>
        )}
      </div>
    </motion.div>
  );
}